export enum FormFieldTypeEnum {
  TEXT = 'TEXT',
  PASSWORD = 'PASSWORD',
  RADIO_TILE = 'RADIO_TILE',
  AUTOCOMPLETE = 'AUTOCOMPLETE',
  TIME = 'TIME',
  NUMBER = 'NUMBER',
  RADIO = 'RADIO',
  CHECKBOX = 'CHECKBOX',
  PHONE = 'PHONE',
  PICKER = 'PICKER',
  SLIDER = 'SLIDER',
  INPUT_OTP = 'INPUT_OTP',
  CUSTOM_INPUT_OTP = 'CUSTOM_INPUT_OTP',
  DATE = 'DATE',
  SELECT = 'SELECT',
  LONG_TEXT = 'LONG_TEXT',
  SWITCH = 'SWITCH',
  TOGGLE_SELECT = 'TOGGLE_SELECT',
  // SIGNATURE = "SIGNATURE",
  // MULTIPLE_SELECT = "MULTIPLE_SELECT",
  // DATE_RANGE = "DATE_RANGE",
  // INFORMATION = "INFORMATION",
}
